import { useFullUserProfileContext } from "Bands/contexts";
import { UserBooleanAttribute, UserElevatorProximity, UserRoomLocation } from "Bands/types";
import { useUserPreferenceRenderLine } from "Bands/utils";
import { FC } from "react";
import { copy } from "shared/assets";
import { Plus } from "shared/assets/icons";
import { Button, List, MainTeaser, Message } from "shared/components";
import { Spacer } from "shared/layout";
import { Icon } from "shared/styles";
import { ITheme } from "shared/types";

const { userHotelPreferences: bodyCopy } = copy;

interface Props {
  handleShowModal?: (v: boolean) => void;
}

export const UserHotelPreferences: FC<Props> = ({ handleShowModal }) => {
  const { hasHotelPreferences, hotelPreferences } = useFullUserProfileContext();

  const { smokingRoom, accessibleRoom, roomLocation, elevatorProximity } = hotelPreferences || {};

  const { renderLine } = useUserPreferenceRenderLine();

  const renderTeaser = () => (
    <List>
      {renderLine(
        bodyCopy.fields.smokingRoom,
        smokingRoom ? UserBooleanAttribute.yes : UserBooleanAttribute.no
      )}
      {renderLine(
        bodyCopy.fields.accessibleRoom,
        accessibleRoom ? UserBooleanAttribute.yes : UserBooleanAttribute.no
      )}
      {renderLine(
        bodyCopy.fields.roomLocation.title,
        (roomLocation ?? UserRoomLocation.none).replaceAll("_", " ")
      )}
      {renderLine(
        bodyCopy.fields.elevatorProximity.title,
        (elevatorProximity ?? UserElevatorProximity.none).replaceAll("_", " ")
      )}
    </List>
  );

  return (
    <>
      {hasHotelPreferences ? (
        <MainTeaser
          subTitleComponent={renderTeaser()}
          actions={
            handleShowModal && [
              {
                label: copy.actions.edit,
                handleClick: () => handleShowModal(true),
              },
            ]
          }
        />
      ) : (
        <Spacer size="s">
          <Message>No hotel preferences added yet</Message>
          <Spacer size="s">
            <Button
              onClick={() => handleShowModal && handleShowModal(true)}
              theme={ITheme.secondary}
            >
              <Icon as={Plus} />
              <span>Add hotel preferences</span>
            </Button>
          </Spacer>
        </Spacer>
      )}
    </>
  );
};
